import { isVideoUrl } from '../config/cloudinary';
import { BLOG_HERO_VIDEO } from '../media/blogHeroMedia';
import {
  isVideoWarm,
  preloadVideoUrl,
  whenVideoReady,
} from './preloadMedia';
import { normalizeBlogTopicKey, pickFeaturedDiagonalVideo } from '../components/blog/blogPostsData';

export { isVideoWarm, whenVideoReady };

const preloaded = new Set();

function preloadOnce(href, options = {}) {
  if (!href || preloaded.has(href)) return;
  preloaded.add(href);
  preloadVideoUrl(href, options);
}

/** Hero + two diagonal card clips for the active blog listing topic (3 videos max). */
export function preloadBlogListingTopic(topicKey, videoPool) {
  if (!videoPool?.length) return;
  const key = normalizeBlogTopicKey(topicKey);
  preloadOnce(BLOG_HERO_VIDEO, { warmElement: true });
  [0, 1].forEach((slot) => {
    const href = pickFeaturedDiagonalVideo(key, slot, videoPool);
    if (href) preloadOnce(href, { warmElement: true });
  });
}

/** Above-the-fold hero for one article; related clips load later. */
export function preloadBlogDetailHero(href, { warm = true } = {}) {
  if (!isVideoUrl(href)) return;
  preloadOnce(href, { warmElement: warm });
}

/** Related cards — link preload only, no duplicate warm elements. */
export function preloadBlogDetailRelated(urls = []) {
  urls.forEach((href) => {
    if (isVideoUrl(href)) {
      preloadOnce(href, { warmElement: false });
    }
  });
}

export function getBlogDetailRelatedVideoUrls(relatedPosts = []) {
  const urls = [];
  const seen = new Set();
  relatedPosts.forEach((post) => {
    const href = post?.image;
    if (!isVideoUrl(href) || seen.has(href)) return;
    seen.add(href);
    urls.push(href);
  });
  return urls;
}
